import styled from "styled-components";

import { breakpoint } from "src/library/utils";

import Grid from "../Hedron";

export default styled(Grid.Box)`
  padding: ${({ theme }) => theme.spacing.padding.md};
  width: 100%;
  flex: 0 0 100%;

  ${({ theme }) => breakpoint("sm", theme)} {
    width: calc(100% / 2);
    flex: 0 0 auto;
  }

  /* ${({ theme }) => breakpoint("md", theme)} {
    width: calc(100% / 3);
  } */

  ${({ theme }) => breakpoint("lg", theme)} {
    width: calc(100% / 3);
    flex: 0 0 auto;
  }

  ${({ theme }) => breakpoint("xxl", theme)} {
    width: calc(100% / 4);
    flex: 1 1 auto;
  }
`;
